// Sdílení příspěvků s možností kopie do clipboardu

import * as Sentry from '@sentry/browser';
import { copyToClipboard } from '@utils/clipboard';
import * as els from './forumElements';

interface ModalShareState {
  commentLink: string;
}

//  TODO: unit testy https://cncenter.atlassian.net/browse/FEG-657
export const forumShareComment = () => {
  // UI a data modalu
  let state: ModalShareState = {
    commentLink: '',
  };

  const modal = els.modalShare;

  if (!modal) return;

  const commentLink: HTMLButtonElement | null = modal.querySelector('.forum__share-comment-link');
  const buttonCopy: HTMLButtonElement | null = modal.querySelector('[data-clipboard-comment-link]');
  const commentLinkFacebook: HTMLLinkElement | null = modal.querySelector(
    '[ data-comment-link--facebook]'
  );
  const commentLinkTwitter: HTMLLinkElement | null = modal.querySelector(
    '[ data-comment-link--twitter]'
  );
  const commentLinkEmail: HTMLLinkElement | null = modal.querySelector(
    '[ data-comment-link--email]'
  );
  const { threadId } = modal.dataset;

  if (!buttonCopy || !threadId || !commentLink) return;

  // Pro všechny tlačítk 'Sdílet'
  els.buttonsShare.forEach((button) => {
    // Po kliknutí
    button.addEventListener('click', () => {
      const commentId = button.getAttribute('data-share-comment');

      // Odkaz vložit do stavu
      if (commentId) {
        state = {
          commentLink: `${window.location.href
            .replace(window.location.hash, '')
            .toString()}#msg_${commentId}`,
        };
      }
      // Odkaz vložit do obsahu modalu
      commentLink.innerHTML = state.commentLink;

      // Pro odkaz na Facebook
      const metaFbAppId = document.querySelector('meta[property="fb:app_id"]');
      const fbAppId = metaFbAppId ? metaFbAppId.getAttribute('content') : '';

      if (commentLinkFacebook)
        commentLinkFacebook.href = `https://www.facebook.com/dialog/share?app_id=${fbAppId}&display=popup&href=${encodeURIComponent(
          state.commentLink
        )}&redirect_uri=${encodeURIComponent(state.commentLink)}`;

      // Pro odkaz na Twitter
      if (commentLinkTwitter)
        commentLinkTwitter.href = `https://x.com/intent/post?url=${encodeURIComponent(
          state.commentLink
        )}`;

      // Pro odkaz na email
      if (commentLinkEmail)
        commentLinkEmail.href = `mailto:?subject=Odkaz na zajímavou diskuzi&body=${encodeURIComponent(
          state.commentLink
        )}`;
    });
  });

  // V modálním okně po kliknutí na potvrzovací tlačítko
  buttonCopy.addEventListener('click', (e): void => {
    (async () => {
      e.preventDefault();

      // Načíst odkaz ze stavu a uložit do schránky
      await copyToClipboard({ text: state.commentLink });

      // Skrýt modal
      els.closeModal(modal);
    })()
      .then(() => {
        /* Žádná logika po načtení */
      })
      .catch((err) => {
        Sentry.captureException(err);
      });
  });
};
